export default "__VITE_ASSET__3f814d1b__"